import { EnvironmentCluster, MOMRegion } from 'libs.react';
const APP_ENV_MAP = {
    [EnvironmentCluster.CN_DEV]: '-dev',
    [EnvironmentCluster.CN_ALI_PLATFORM]: '-platform',
    [EnvironmentCluster.CN_PROD]: '',
    [EnvironmentCluster.DEMO]: '-demo',
    [EnvironmentCluster.DEV]: '-dev',
    [EnvironmentCluster.EDGE]: '-edge',
    [EnvironmentCluster.EPHEMERAL]: '',
    [EnvironmentCluster.EU]: '-eu1',
    [EnvironmentCluster.EU_DEV]: '-eu1-dev',
    [EnvironmentCluster.INT_DEV]: '-int-dev',
    [EnvironmentCluster.LOCAL]: '-local',
    [EnvironmentCluster.PLATFORM]: '-platform',
    [EnvironmentCluster.PROD]: '',
    [EnvironmentCluster.QA]: '-qa',
    [EnvironmentCluster.TEST]: '-test',
};
const getEnvironmentStatus = (environment) => {
    const workflow = getEnvironmentWorkflow(environment);
    if (workflow?.status === 'completed' && hasExpired(environment)) {
        return 'expired';
    }
    if (workflow) {
        return workflow.status || 'active';
    }
    return environment.metadata.packages.length > 0 ? 'completed' : 'failed';
};
const buildEnvironmentUrl = ({ app = 'apps-dashboard', routePage = '', environment, }) => {
    const iamServiceEndPoint = process.env.IAM_SERVICE_ENDPOINT;
    const buildSsoTokenUrl = (redirectUrl) => `${iamServiceEndPoint}/v1/sso/token?aud=${environment.cortexURL}/${environment.code}&redirect_url=${encodeURIComponent(redirectUrl)}`;
    if (environment.deployment.cluster === EnvironmentCluster.EPHEMERAL) {
        const cortexWeb = environment.cortexURL.replace('api', app);
        const redirectUrl = `${cortexWeb}/${routePage}?orgCode=${environment.code}`;
        return app === 'portal' && iamServiceEndPoint ? buildSsoTokenUrl(redirectUrl) : redirectUrl;
    }
    // If map doesn't include cluster, we default to the provided cluster as we consider production clusters covered
    const appEnv = APP_ENV_MAP[environment.deployment.cluster] ?? `-${environment.deployment.cluster}`;
    const domain = environment.deployment.region === MOMRegion.CN ? 'cn' : 'com';
    const redirectUrl = `https://${app}${appEnv}.medable.${domain}/${routePage}?orgCode=${environment.code}`;
    // Portal owns Study Manager login. Start through IAM SSO so the new tab carries the redirect context
    // instead of relying on an existing portal-* cookie and falling back to /login.
    if (iamServiceEndPoint && (app === 'portal' || environment.deployment.region === MOMRegion.CN)) {
        return buildSsoTokenUrl(redirectUrl);
    }
    return redirectUrl;
};
const getEnvironmentWorkflow = (environment) => {
    return environment.workflows[0];
};
const isUATEnvironment = (environment) => {
    return isTimeTravelEnvironment(environment) && environment.metadata.backupEnabled;
};
const isTimeTravelEnvironment = (environment) => {
    return environment.cluster === EnvironmentCluster.EPHEMERAL;
};
const hasExpired = (environment) => {
    if (isTimeTravelEnvironment(environment) && environment.metadata.expiresAt) {
        return environment.metadata.expiresAt < new Date().toISOString();
    }
    return false;
};
export const DeploymentUtils = {
    buildEnvironmentUrl,
    getEnvironmentWorkflow,
    getEnvironmentStatus,
    hasExpired,
    isUATEnvironment,
    isTimeTravelEnvironment,
};
